import { toast } from 'sonner'
import { materialsApi, getErrorMessage } from '@/lib/api'

/**
 * Download a material's file to the user's device.
 *
 * The download endpoint streams the bytes through the API and requires the JWT
 * Authorization header, so a plain `<a href>` or `window.open` cannot be used.
 * Instead we fetch the bytes via the authenticated axios client (as a Blob),
 * wrap them in an object URL, and trigger a synthetic `<a download>` click.
 *
 * Shared by the material preview drawer and the material card's three-dots menu
 * so both download the same way. On failure it shows a single error toast
 * (`skipErrorToast` keeps the axios interceptor from adding a duplicate).
 */
export async function downloadMaterial(id: number, filename?: string): Promise<void> {
  let blobUrl: string | null = null
  try {
    blobUrl = await materialsApi.getPreviewBlob(id, { skipErrorToast: true })
    const a = document.createElement('a')
    a.href = blobUrl
    a.download = filename || `material-${id}`
    document.body.appendChild(a)
    a.click()
    a.remove()
  } catch (error) {
    toast.error(getErrorMessage(error, 'Download failed. Please try again.'))
  } finally {
    if (blobUrl) {
      const url = blobUrl
      setTimeout(() => URL.revokeObjectURL(url), 1000)
    }
  }
}
